// Main exports - React components
export { PortfolioConnect } from './PortfolioConnect';
export { PortfolioConnectWidget } from './components/PortfolioConnectWidget';
export { requestAccessToken, isAccessToken } from './utils/api';

// Imperative API for non-React users (Vanilla JS, Angular, Vue, etc.)
export { open, create } from './imperative';
export type { ImperativeConfig, OpenResult, WidgetHandle } from './imperative';

// SDK Version
export const VERSION = '2.2.0';
export const SDK_NAME = 'Portfolio Connect';

// Type exports (new names)
export type {
  PortfolioConnectProps,
  PortfolioConnectConfig,
  PortfolioConnectTheme,
  PortfolioType,
  PortfolioConnectError,
  PortfolioConnectErrorCode,
  PortfolioConnectEvent,
  ParsedData,
  InvestorInfo,
  ParseMetadata,
  EventMetadata,
  RenderProps,
  BrokerInfo,
  InboxFile,
  InboundEmailFile,
  SubmitInput,
} from './types';

// Error classification helper (lets embedders classify raw API errors
// the same way the widget does internally).
export { classifyError } from './utils/errors';
export type { ClassifiedError, ErrorCode } from './utils/errors';

// Pure helper that turns a /v4/smart/parse response into a stable
// summary ({ totalValue, folios, holdings, asOn, casType, investorName }).
// Use this if you're rendering your own post-import UI and don't want
// to reverse-engineer the API response shape.
export {
  extractPortfolioSummary,
  countHoldingsInAccount,
  friendlyCasType,
} from './utils/extractSummary';
export type { ParsedPortfolioSummary } from './utils/extractSummary';

// Success-summary screen — exported so embedders can render the same
// post-import UI in their own flows (e.g. inside a different layout).
export { SuccessSummary } from './components/SuccessSummary';

// Inbox OAuth callback handler - developers must call this on their redirect page
export { handleInboxCallback, isInboxCallbackPage } from './utils/inboxCallback';
export type { InboxCallbackResult, InboxOAuthMessage } from './utils/inboxCallback';

